import * as actionTypes from '../actions/actionTypes'

const initialState = {
  orders : []
}

const deliveryTrackingReducer = (state = initialState, actions)  => {
  switch(actions.type){
    case actionTypes.GET_ORDERS_DELIVERY_TRACKING_SUCCESS:
      return {
        ...state,
        orders : [...actions.orders]
      }
    default:
      return state
  }
}

export default deliveryTrackingReducer



// WEBPACK FOOTER //
// ./src/store/reducers/deliveryTrackingReducer.js